function BillToCompany() {
    return (
      <>
        <div className="font-bold text-lg mb-16">BillToCompany</div>
      </>
    );
  }
  
  export default BillToCompany;